module.exports = __webpack_public_path__ + "static/img/banner-2.adfeb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/banner-2.png
// module id = 3BUI
// module chunks = 10